module.exports = __webpack_public_path__ + "static/secondMovementLastSnippet1-8cbe1fc115aed26d31f339321a8b5113.mp3";